<template>
  <BreadCrumb PageTitle="Colored Links" />
  <ColoredLinks />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ColoredLinks from "../../template-components/UIElements/ColoredLinks/ColoredLinks.vue";

export default defineComponent({
  name: "ColoredLinksPage",
  components: {
    BreadCrumb,
    ColoredLinks,
  },
});
</script>